/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ChildrenStats } from '../model/childrenStats';
import { PaginatedChildrenStatsList } from '../model/paginatedChildrenStatsList';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ChildPortfolioStatisticsService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * List children with skill/competence/literacy stats
     * Read-only ViewSet that provides statistics about children’s watched and touched skills, competencies and literacies.
     * @param dateEnd 
     * @param dateStart 
     * @param groupUuid 
     * @param limit Number of results to return per page.
     * @param offset The initial index from which to return the results.
     * @param ordering Which field to use when ordering the results.
     * @param search A search term.
     * @param touchedCompetenceId 
     * @param touchedLiteracyId 
     * @param touchedSkillId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public childPortfolioChildrenStatsList(dateEnd?: string, dateStart?: string, groupUuid?: string, limit?: number, offset?: number, ordering?: string, search?: string, touchedCompetenceId?: string, touchedLiteracyId?: string, touchedSkillId?: string, observe?: 'body', reportProgress?: boolean): Observable<PaginatedChildrenStatsList>;
    public childPortfolioChildrenStatsList(dateEnd?: string, dateStart?: string, groupUuid?: string, limit?: number, offset?: number, ordering?: string, search?: string, touchedCompetenceId?: string, touchedLiteracyId?: string, touchedSkillId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PaginatedChildrenStatsList>>;
    public childPortfolioChildrenStatsList(dateEnd?: string, dateStart?: string, groupUuid?: string, limit?: number, offset?: number, ordering?: string, search?: string, touchedCompetenceId?: string, touchedLiteracyId?: string, touchedSkillId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PaginatedChildrenStatsList>>;
    public childPortfolioChildrenStatsList(dateEnd?: string, dateStart?: string, groupUuid?: string, limit?: number, offset?: number, ordering?: string, search?: string, touchedCompetenceId?: string, touchedLiteracyId?: string, touchedSkillId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {











        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (dateEnd !== undefined && dateEnd !== null) {
            queryParameters = queryParameters.set('date_end', <any>dateEnd);
        }
        if (dateStart !== undefined && dateStart !== null) {
            queryParameters = queryParameters.set('date_start', <any>dateStart);
        }
        if (groupUuid !== undefined && groupUuid !== null) {
            queryParameters = queryParameters.set('group_uuid', <any>groupUuid);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (ordering !== undefined && ordering !== null) {
            queryParameters = queryParameters.set('ordering', <any>ordering);
        }
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('search', <any>search);
        }
        if (touchedCompetenceId !== undefined && touchedCompetenceId !== null) {
            queryParameters = queryParameters.set('touched_competence_id', <any>touchedCompetenceId);
        }
        if (touchedLiteracyId !== undefined && touchedLiteracyId !== null) {
            queryParameters = queryParameters.set('touched_literacy_id', <any>touchedLiteracyId);
        }
        if (touchedSkillId !== undefined && touchedSkillId !== null) {
            queryParameters = queryParameters.set('touched_skill_id', <any>touchedSkillId);
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<PaginatedChildrenStatsList>('get',`${this.basePath}/child-portfolio/children-stats/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Return all competences for child or group as Excel file.
     * @param dateEnd 
     * @param dateStart 
     * @param groupUuid 
     * @param ordering Which field to use when ordering the results.
     * @param search A search term.
     * @param touchedCompetenceId 
     * @param touchedLiteracyId 
     * @param touchedSkillId 
     * @param type Export type: &#x27;csv&#x27; or &#x27;xlsx&#x27;
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public childPortfolioChildrenStatsPrintRetrieve(dateEnd?: string, dateStart?: string, groupUuid?: string, ordering?: string, search?: string, touchedCompetenceId?: string, touchedLiteracyId?: string, touchedSkillId?: string, type?: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public childPortfolioChildrenStatsPrintRetrieve(dateEnd?: string, dateStart?: string, groupUuid?: string, ordering?: string, search?: string, touchedCompetenceId?: string, touchedLiteracyId?: string, touchedSkillId?: string, type?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public childPortfolioChildrenStatsPrintRetrieve(dateEnd?: string, dateStart?: string, groupUuid?: string, ordering?: string, search?: string, touchedCompetenceId?: string, touchedLiteracyId?: string, touchedSkillId?: string, type?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public childPortfolioChildrenStatsPrintRetrieve(dateEnd?: string, dateStart?: string, groupUuid?: string, ordering?: string, search?: string, touchedCompetenceId?: string, touchedLiteracyId?: string, touchedSkillId?: string, type?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {










        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (dateEnd !== undefined && dateEnd !== null) {
            queryParameters = queryParameters.set('date_end', <any>dateEnd);
        }
        if (dateStart !== undefined && dateStart !== null) {
            queryParameters = queryParameters.set('date_start', <any>dateStart);
        }
        if (groupUuid !== undefined && groupUuid !== null) {
            queryParameters = queryParameters.set('group_uuid', <any>groupUuid);
        }
        if (ordering !== undefined && ordering !== null) {
            queryParameters = queryParameters.set('ordering', <any>ordering);
        }
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('search', <any>search);
        }
        if (touchedCompetenceId !== undefined && touchedCompetenceId !== null) {
            queryParameters = queryParameters.set('touched_competence_id', <any>touchedCompetenceId);
        }
        if (touchedLiteracyId !== undefined && touchedLiteracyId !== null) {
            queryParameters = queryParameters.set('touched_literacy_id', <any>touchedLiteracyId);
        }
        if (touchedSkillId !== undefined && touchedSkillId !== null) {
            queryParameters = queryParameters.set('touched_skill_id', <any>touchedSkillId);
        }
        if (type !== undefined && type !== null) {
            queryParameters = queryParameters.set('type', <any>type);
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request('get',`${this.basePath}/child-portfolio/children-stats/print/`,
            {
                params: queryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Read-only ViewSet that provides statistics about children’s watched and touched skills, competencies and literacies.
     * @param childUuid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public childPortfolioChildrenStatsRetrieve(childUuid: string, observe?: 'body', reportProgress?: boolean): Observable<ChildrenStats>;
    public childPortfolioChildrenStatsRetrieve(childUuid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ChildrenStats>>;
    public childPortfolioChildrenStatsRetrieve(childUuid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ChildrenStats>>;
    public childPortfolioChildrenStatsRetrieve(childUuid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (childUuid === null || childUuid === undefined) {
            throw new Error('Required parameter childUuid was null or undefined when calling childPortfolioChildrenStatsRetrieve.');
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ChildrenStats>('get',`${this.basePath}/child-portfolio/children-stats/${encodeURIComponent(String(childUuid))}/`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
